import { type AnalyticsData, formatUrlToStr } from '@mwl/core-lib';

import type { AdditionalSportListAnalytics, GetBaseSportListAnalytics } from './SportList.types';

export const getBaseSportListAnalytics: GetBaseSportListAnalytics = (sportItem, href, filteredSports) => {
  const analyticsData: AnalyticsData = {
    id: sportItem.id,
    href: formatUrlToStr(href),
    text: sportItem.title,
    count: filteredSports.length,
    position: filteredSports.findIndex((filteredSport) => filteredSport.id === sportItem.id) + 1,
    sport_category: sportItem.code,
  };

  return {
    baseSportsAnalytics: {
      select: {
        eventName: 'sportLeftSideBar_sportList_select',
        data: analyticsData,
      },
      unselect: {
        eventName: 'sportLeftSideBar_sportList_unselect',
        data: analyticsData,
      },
    },
  };
};

export const additionalSportListAnalytics: AdditionalSportListAnalytics = {
  topsAnalytics: {
    click: {
      eventName: 'sportLeftSideBar_topevents_click',
    },
  },
  favoritesAnalytics: {
    click: {
      eventName: 'sportLeftSideBar_favorite_click',
    },
  },
};
